/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { connectHits } from "react-instantsearch-dom";
import styled from "styled-components";

import { Hit } from "src/components/Search/Hits/Hit";
import { CustomStats } from "src/components/Search/SearchPiping";
import { SearchHit } from "src/lib/types";

interface Props {
  hits: SearchHit[];
}

const Hits = ({ hits }: Props) => (
  <>
    {hits.length > 0 && (
      <ResultsHeader>
        <CustomStats />
      </ResultsHeader>
    )}
    <ol>
      {hits.map((hit: SearchHit) => (
        <Hit hit={hit} key={hit.objectID} enableKeyboardNav />
      ))}
    </ol>
  </>
);
const ResultsHeader = styled.div`
  background-color: #f5f5f5;
  font-weight: 400;
  font-size: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 16px;
  color: #aeaeae;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const CustomHits: any = connectHits(Hits);
